import * as React from 'react';

import {Icon} from '@spaced-out/ui-design-system/lib/components/Icon';
import {Tooltip} from '@spaced-out/ui-design-system/lib/components/Tooltip';

import useLabelTranslation from 'src/hooks/useLabelTranslation';
import {useHistory} from 'src/rerouter';

import css from './dashboard-builder-canvas-layout.css';


export type AddRowDividerProps = {
  afterIndex: number;
  pathname: string;
  onAddSection: (afterIndex: number) => void;
};

export const AddRowDivider = React.memo(
  ({afterIndex, pathname, onAddSection}: AddRowDividerProps) => {
    const {t} = useLabelTranslation();
    const history = useHistory();

    return (
      <div className={css.rowDivider}>
        <div className={css.rowDividerInner}>
          <div className={css.rowDividerLine} />
          <div className={css.rowDividerActions}>
            <Tooltip body={t('Add_Section', 'Add Section')} placement="top">
              <button
                type="button"
                className={css.rowDividerBtn}
                onClick={() => onAddSection(afterIndex)}
                aria-label={t('Add_Section', 'Add Section')}
              >
                <Icon
                  name="square-a"
                  type="solid"
                  size="medium"
                  color="clickable"
                />
              </button>
            </Tooltip>
            <Tooltip body={t('Add_Report', 'Add Report')} placement="top">
              <button
                type="button"
                className={css.rowDividerBtn}
                onClick={() =>
                  history.push(`${pathname}/widget/add?after=${afterIndex}`)
                }
                aria-label={t('Add_Report', 'Add Report')}
              >
                <Icon
                  name="square-poll-vertical"
                  type="solid"
                  size="medium"
                  color="clickable"
                />
              </button>
            </Tooltip>
          </div>
        </div>
      </div>
    );
  },
);
